import { Box, Button, Typography } from "@bca/ui-library";
import React from "react";

interface FiltersHeaderProps {
  isClearAllDisabled: boolean;
  onClearAll: () => void;
}

const FiltersHeader: React.FunctionComponent<FiltersHeaderProps> = ({
  onClearAll,
  isClearAllDisabled,
}) => (
  <Box display="flex" flexDirection="row" marginBottom={4}>
    <Box>
      <Typography variant="h6" m={0}>
        FILTER BY
      </Typography>
    </Box>
    <Box>
      <Button
        fontSize="body-small"
        height="19px"
        variant="tertiary"
        icon="trash"
        iconHeight="14px"
        iconWidth="13px"
        padding="0"
        marginLeft="57px"
        disabled={isClearAllDisabled}
        onClick={onClearAll}
        data-en="click"
        data-ec="button"
        data-el="filter"
        data-ea="clear-all"
        data-es=""
      >
        Clear All
      </Button>
    </Box>
  </Box>
);

export default FiltersHeader;
